export const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "admin" */ './Dashboard.vue')
  }
];
